import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import {
  GENERAL_CONSTANTS,
  OPTIONS_LOCALE_DATE,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { SearchContext } from "@/shared/models/SearchContext";
import { Utils } from "@/shared/utils/utils";
import store from "@/store";
import { Http } from "@status/codes";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";
import { mapGetters } from "vuex";
import { CrudChartRenderData } from "../Dashboards/AdminDashboard/models/CrudChartRenderData";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import {
  INFO_CHART_NAMES,
  INFO_GROUP_CONSTANTS,
  USER_TEMPLATE_SECONDARY_FILTERS
} from "../InfoGroup/constants/InfoGroupConstants";
import {
  USER_FILTERS_LIST,
  USER_TEMP_CONSTANTS,
  USER_TEMPLATES_ACCESS
} from "./constants/UserTemplateConstants";
import { UserTemplateService } from "./services/UserTemplateService";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { UserTempQuerySend } from "./models/UserTempQuerySend";
import { HeaderUserTemplate } from "./models/HeaderUserTemplate";
import { Response } from "@/shared/models/Response";
import { UserTempDataResponse } from "./models/UserTempDataResponse";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import SaveUserTemplate from "./components/SaveUserTemplate/SaveUserTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import FormModalViewer from "@/shared/components/FormModalViewer/FormModalViewer.vue";
import SaveInfoGroup from "../InfoGroup/components/SaveInfoGroup/SaveInfoGroup.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { UserTemplateSchema } from "./models/UserTemplateSchema";
import { InfoGroupService } from "../InfoGroup/services/InfoGroupService";
import { SearchContextModal } from "@/shared/models/SearchContextModal";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "UserTemplate",
  components: {
    CrudChart,
    ModalTemplate,
    SaveUserTemplate,
    SaveInfoGroup,
    FormModalViewer,
    ObservationModal,
    EmptyState
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class UserTemplate extends Vue {
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() infoGroupService!: InfoGroupService;
  dataToMainView!: MenuDataStructure;
  admin = false;
  OPERATIONS = [LIST_DATA_EVENTS.VIEW_DATA];
  isLoadingChart = false;
  showChart = false;
  filterItems: Filter = USER_FILTERS_LIST;
  TITLE_PAGE = USER_TEMP_CONSTANTS.PAGE_TITLE;
  userTemplateChartData: CrudChartRenderData = CHART_INIT;
  EMPTY_STATE_HEADER = INFO_GROUP_CONSTANTS.EMPTY_STATE.EMPTY_STATE_HEADER;
  EMPTY_STATE_PARAGRAPH =
    INFO_GROUP_CONSTANTS.EMPTY_STATE.EMPTY_STATE_PARAGRAPH;
  filterQuery: UserTempQuerySend = { chart: "true" };
  canSearch = false;
  userTemplateList: HeaderUserTemplate[] = [];
  docRef = "";
  loadingUserTemplates = false;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  currentTooltip = USER_TEMP_CONSTANTS.BUTTON.ADD_USER_TEMP_TEXT;
  userTemplateIdProp = "";
  isVisibleSaveUserTemplate = false;
  clearModel = false;
  showModalAddList = false;
  cardClass = STYLE_CLASSES.CARD;
  dialogPreview = false;
  userTempData: UserTemplateSchema = new UserTemplateSchema();
  ADD_PAGE_TITLE = USER_TEMP_CONSTANTS.ADD_PAGE_TITLE;

  actionCancel = COMPONENT_NAME_MODAL.USER_TEMPLATE;
  options = OPTIONS_LOCALE_DATE;
  dateCreated = "";
  dateChanged = "";
  refreshlistInfoGroup = 0;

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);
    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.USER_TEMPLATE
    );

    this.searchData();
    this.emitSearchInitializer();
  }

  async beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    await this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  initializeFilters() {
    this.filterItems.secondaryFilters = [];
    this.filterItems.secondaryFilters.push(
      USER_TEMPLATE_SECONDARY_FILTERS.NAME
    );
    this.filterItems.secondaryFilters.push(
      USER_TEMPLATE_SECONDARY_FILTERS.STATUS
    );
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  emitSearchInitializer() {
    this.initializeFilters();
    const searchContext: SearchContext = {
      title: USER_TEMP_CONSTANTS.PAGE_USER_TEMP_TITLE_SEARCH,
      filterArray: [this.filterItems],
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.USER_TEMPLATE,
      descriptions: ["description", "state"],
      textButtonCreate: USER_TEMP_CONSTANTS.BUTTON.ADD_USER_TEMP_TEXT
    };

    const data = searchContext;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      data
    );
  }

  async getDataByFilter(
    loadPages?: boolean
  ): Promise<Response<UserTempDataResponse>> {
    try {
      if (loadPages) this.filterQuery.docref = this.docRef;
      const data = await this.userTemplateService.getUserTempByFilters(
        this.filterQuery
      );
      return data;
    } catch (error) {
      const RESPONSE_ERROR: Response<UserTempDataResponse> = {
        code: Http.BadRequest,
        message:
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.GET}`
            : INFO_GROUP_CONSTANTS.DIALOG_MESSAGE.ERROR,
        data: {
          templates: [],
          chartData: {},
          docref: ""
        }
      };
      return RESPONSE_ERROR;
    }
  }

  async searchData() {
    this.isLoadingChart = true;
    this.showChart = false;
    this.canSearch = false;
    this.userTemplateList = [];

    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );
    const response = await this.getDataByFilter();
    if (response.code === Http.Found && response.data !== undefined) {
      this.userTemplateList = response.data.templates;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.userTemplateList
      );
      if (response.data.chartData) {
        this.userTemplateChartData = {
          chartTitle: USER_TEMP_CONSTANTS.PAGE_USER_TEMP_TITLE_SEARCH,
          chartRenderData: Utils.mapChartData(
            response.data.chartData,
            INFO_CHART_NAMES.STATES
          )
        };
      }
      this.showChart = true;
      this.docRef = response.data.docref;
      this.canSearch = true;
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if (response.code === Http.NotFound) {
        Snackbar.popInfo(response.message);
      } else {
        Snackbar.popError(response.message);
      }
      this.showChart = false;
    }
    this.isLoadingChart = false;
  }

  getFilter() {
    const query: UserTempQuerySend = { chart: "true" };
    if ("name" in this.dataToMainView.data) {
      const nameValue = this.dataToMainView.data["name"][0];
      if (nameValue) query.name = nameValue;
    }
    if ("status" in this.dataToMainView.data) {
      const stateValues = this.dataToMainView.data["status"] as Array<string>;
      if (stateValues && stateValues.length == 1) query.state = stateValues[0];
    }
    return query;
  }

  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.filterQuery = this.getFilter();
          this.searchData();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
      }
    } else if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.OPTIONS) {
      if (
        this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.SHOW_ADD_LIST
      ) {
        this.activeModalAddList();
      }
    }
  }

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  async clickData(label: string) {
    this.filterQuery = {
      state: label,
      chart: "true"
    };
    await this.searchData();
  }

  async clickOut() {
    this.filterQuery = {
      chart: "true",
      state: STATE.ACTIVE
    };
    await this.searchData();
  }

  show(val: boolean) {
    this.isVisibleSaveUserTemplate = val;
    if (val) {
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.currentTooltip = USER_TEMP_CONSTANTS.BUTTON.TOOLTIP_CANCEL;
    } else {
      this.userTemplateIdProp = "";
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        this.userTemplateIdProp
      );
      this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
      this.currentTooltip = USER_TEMP_CONSTANTS.BUTTON.ADD_USER_TEMP_TEXT;
      this.TITLE_PAGE = USER_TEMP_CONSTANTS.PAGE_TITLE;
    }
  }

  callCancelModal() {
    const modalUserTemplate: SearchContextModal = {
      componentName: this.actionCancel
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  showUserTemplate(id: string, action: string) {
    if (action === this.ADD_PAGE_TITLE) {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.userTemplateIdProp = "";
        this.show(true);
        this.TITLE_PAGE = this.ADD_PAGE_TITLE;

        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL,
          { showOptions: this.isVisibleSaveUserTemplate }
        );
      } else {
        this.actionCancel = COMPONENT_NAME_MODAL.USER_TEMPLATE;
        this.callCancelModal();
      }
    } else if (action === USER_TEMP_CONSTANTS.EDIT_PAGE_TITLE) {
      this.userTemplateIdProp = id;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        id
      );
      this.show(true);
      this.TITLE_PAGE = USER_TEMP_CONSTANTS.EDIT_PAGE_TITLE;
    }
  }

  async deleteUserTemplate(id: string) {
    try {
      const responseData = await this.userTemplateService.deleteUserTemp(id);
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(
          USER_TEMP_CONSTANTS.DIALOG_MESSAGE.USER_TEMP_DELETED
        );
        await this.searchData();
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  activeModalAddList() {
    this.showModalAddList = true;
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editUserTemp(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        await this.deleteUserTemplate(itemId);
        this.userTemplateIdProp = "";
        this.show(false);
        break;
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.showUserTempDetails(itemId);
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateUserTemplate(itemId, STATE.ACTIVE);
        this.userTemplateIdProp = "";
        this.show(false);
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateUserTemplate(itemId, STATE.INACTIVE);
        this.userTemplateIdProp = "";
        this.show(false);
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        switch (this.actionCancel) {
          case COMPONENT_NAME_MODAL.USER_TEMPLATE:
            this.userTemplateIdProp = "";
            this.show(false);
            break;
          case COMPONENT_NAME_MODAL.INFO_GROUP:
            this.showModalAddList = false;
            break;
        }
        break;
    }
  }

  async updateStateUserTemplate(id: string, state: string) {
    try {
      const responseData = await this.userTemplateService.updateStateUserTempById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(
          USER_TEMP_CONSTANTS.DIALOG_MESSAGE.SAVE_MESSAGE_SUCCESS
        );
        await this.searchData();
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  editUserTemp(itemId: string) {
    this.showUserTemplate(itemId, USER_TEMP_CONSTANTS.EDIT_PAGE_TITLE);
  }

  async showUserTempDetails(itemId: string) {
    try {
      const response = await this.userTemplateService.getUserTempSchemaById(
        itemId
      );
      if (response.code === Http.Found && response.data != null) {
        this.userTempData = response.data;
        if (response.data.dateChanged) {
          this.dateChanged = new Date(
            response.data.dateChanged
          )?.toLocaleDateString("es-CO", this.options);
        }
        if (response.data.dateCreated) {
          this.dateCreated = new Date(
            response.data.dateCreated
          )?.toLocaleDateString("es-CO", this.options);
        }
        this.clearModel = true;
        this.dialogPreview = true;
      } else if (response.code === Http.NotFound) {
        this.userTempData.phoneComponentList = [];
        Snackbar.popInfo(response.message);
      } else {
        this.userTempData.phoneComponentList = [];
        Snackbar.popInfo(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${USER_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  closeModalPreview() {
    this.dialogPreview = false;
    this.clearModel = false;
    this.userTempData.phoneComponentList = [];
  }

  onButtonAdd() {
    this.showUserTemplate("", this.ADD_PAGE_TITLE);
  }
}
